export const perspectiveCustomerId = (
  operationCustomerId: unknown,
  storedCustomerId: string | null,
): string =>
  typeof operationCustomerId === "string"
    ? operationCustomerId
    : storedCustomerId || "";
